export default "__VITE_ASSET__42ed7afd__"